// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__307gp","left":"styles_left__2zZMu"};